module.exports = __webpack_public_path__ + "static/media/pronto.535065b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/pronto.jpg
// module id = 956
// module chunks = 0